module.exports = {"150781001":"东山街道","150781002":"道南街道","150781003":"道北街道","150781004":"兴华街道","150781100":"新开河镇","150781400":"满洲里市互市贸易区","150781401":"满洲里市经济合作区","150781402":"满洲里市东湖区","150781403":"满洲里市扎煤公司","150781404":"扎赉诺尔矿区","150781405":"满洲里市工业园区","150781406":"满洲里国际物流产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150781.json
// module id = 408
// module chunks = 0